import { useEffect, useMemo } from "react";

import { currentUserId, currentUserToken } from "../../utils/constants";
import { localStorageInstance } from "../../utils/localStorage";
import { getAuthState, getRedirectLocation } from "../utils/routeUtils";

export function usePrivateRoute(location) {
  const redirectLocation = useMemo(
    () => getRedirectLocation(location),
    [location]
  );

  useEffect(() => {
    localStorageInstance.setItem({
      key: "redirectLocation",
      value: redirectLocation,
    });
  }, [redirectLocation]);

  const auth = getAuthState({
    token: currentUserToken(),
    userId: currentUserId(),
  });

  return {
    isAuthenticated: auth,
  };
}
